import React, { useState, useEffect } from 'react';
import { Button, Modal, message, Switch, Input, Spin } from 'antd';
import LocomotiveHistoryTable from '../Table.js/LocomotiveHistoryTable';
import { useLocation } from 'react-router-dom';
import { DownloadMaintenanceHistory } from '../../../Services/employee';
import { HistoryTable } from '../../../Services/LocomotiveServices';
import useDebounce from '../../FuelManagement/useDebounce';
import { LoadingOutlined } from '@ant-design/icons';

const HistoryModal = ({ visible: open, closeModal }) => {

    const { state } = useLocation()
    const id = state?.data?.id
    const [data, setData] = useState([])
    const [loader, setLoader] = useState(false)
    const [filters, setFilters] = useState({
        toggle: true,
        search: ""
    })


    const handleExportButtonClick = async () => {

        try {
            const response = await DownloadMaintenanceHistory({ id, filters });
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Maintenance History - ${id}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data:', error);
        }
    }

    const debouncedSearch = useDebounce(filters.search, 1000)

    const fetchData = async () => {
        setLoader(true)
        const result = await HistoryTable(state?.data?.id, { search: debouncedSearch, toggle: filters.toggle });
        if (result?.httpStatus == 200) {
            setData(result?.data);
        }
        setLoader(false)

    };

    useEffect(() => {
        if (open) fetchData()
    }, [open, debouncedSearch, filters.toggle])
    useEffect(() => {
        setFilters({ ...filters, search: '' })
    }, [open])

    return (
        <Modal
            open={open}
            title={(
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Maintenance History</span>
                    <Button
                        onClick={handleExportButtonClick}
                        style={{
                            marginRight: '20px',
                            background: '#2863ad',
                            color: "white",
                            borderRadius: "10px",
                        }}>
                        Download
                    </Button>
                </div>
            )}
            className='ModalWidth70'
            okText="Confirm"
            bodyStyle={{ style: { background: 'white' } }}
            titleProps={{ style: { background: 'white', fontWeight: 'bold' } }}
            width="50%"
            footer={null}
            onCancel={() => {
                closeModal()
                setFilters({ toggle: true, search: "" })
            }}
        >
            <Spin
                spinning={loader || false}
                indicator={<LoadingOutlined
                    style={{
                        fontSize: 24,
                    }}
                    spin
                />}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "300px" }}>
                        <span style={{ fontSize: "12px" }}>Exclude Service Tasks</span>
                        <Switch
                            size="small"
                            checked={filters?.toggle}
                            onChange={e => setFilters({ ...filters, toggle: e })}
                        />
                    </div>
                    <Input
                        placeholder='Search by Repairs Made or Repaired By'
                        style={{ width: "300px", fontSize: "12px" }}
                        value={filters?.search}
                        onChange={e => setFilters({ ...filters, search: e.target.value })}
                    />
                </div>
                <LocomotiveHistoryTable flag={open} data={data} setData={setData} />
            </Spin>
        </Modal>
    );
};

export default HistoryModal;
